import React from 'react'

type ListViewIconProps = {
  active: boolean
}

const ListViewIcon: React.FC<ListViewIconProps> = ({ active }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="4.34783" rx="1" fill={active ? '#2D60FF' : '#5B73A0'} />
      <rect y="7.82605" width="20" height="4.34783" rx="1" fill={active ? '#2D60FF' : '#5B73A0'} />
      <rect y="15.6522" width="20" height="4.34783" rx="1" fill={active ? '#2D60FF' : '#5B73A0'} />
    </svg>
  )
}
export default ListViewIcon
